define('views/modules/goal/goal-panel',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/layout',
    // views
    'views/parts/panel/base-panel',
    'views/modules/goal/edit/goal-edit-content'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    LayoutState,
    // views
    VBasePanel,
    VGoalEditContent
) {

    var VGoalPanel = VBasePanel.extend({
        header: {
            title: "goal:Add a goal",
            subtitle: "goal:Add/Modify a goal",
        },

        tabs: [{ id: 'edit', title: 'Edit', active: true }],
        content: {
            edit: VGoalEditContent,
        },
        defaultView: 'edit',

        initialize: function(opt) {
            opt = opt || {};

            var edit = this.getView('edit', {
                profile: opt.profile,
                model: this.model
            });
            this.listenTo(edit, { 'form:success': this.close });
        },

    });

    return VGoalPanel;

});

